import { Box, Grid, Link, Typography, useTheme } from "@mui/material";
import { Command } from "~/components/guides/components/command";
import { Markdown } from "~/components/markdown";
import { IntegrationAddHeader } from "../../headers/IntegrationAddHeader";
import { OtherIntegrations } from "../../headers/types";
import { useToken } from "~/providers/token";
import { formatTokenExpiration } from "../linux/utils";
import { getMacInstallCommand } from "~/pages/integrations/os/macos/utils";
import { MACOS_SCAN_COMMAND } from "~/pages/integrations/os/macos/constants";

export const MacOSIntegrationSetupPage = () => {
  const theme = useTheme();
  const { token, refreshToken, tokenTimeLeft } = useToken();
  const macInstallCommand = getMacInstallCommand(token?.value ?? "");

  return (
    <Box>
      <IntegrationAddHeader type={OtherIntegrations.MACOS} />
      <Box>
        <Box>
          <Command
            number={1}
            options={{
              fontSize: { xs: 16 },
              dotColor: theme.palette.background.lightest,
            }}
          >
            Install cnspec on your macOS workstation
          </Command>
        </Box>
        <Box sx={{ pl: 6, mb: 5 }}>
          <Typography
            variant="body1"
            color="text.secondary"
            sx={{ mt: 2, mb: 1 }}
          >
            Install cnspec by running these commands as root
          </Typography>
          <Markdown source={`\`\`\`bash\n${macInstallCommand}\n\`\`\``} />
          <Typography
            variant="caption"
            color="text.secondary"
            sx={{ ml: 2, mt: -1, display: "block" }}
          >
            Your Mondoo Registration Token expires in{" "}
            {formatTokenExpiration(tokenTimeLeft)}.{" "}
            <Link
              component="button"
              onClick={refreshToken}
              sx={{
                color: "primary.light",
                verticalAlign: "inherit",
                textDecoration: "none",
                "&:hover": { textDecoration: "underline" },
              }}
            >
              Refresh token
            </Link>
            .
          </Typography>
        </Box>

        <Box sx={{ mb: 2 }}>
          <Command
            number={2}
            options={{
              fontSize: { xs: 16 },
              dotColor: theme.palette.background.lightest,
            }}
          >
            Use cnspec to scan your macOS host
          </Command>
        </Box>
        <Box sx={{ pl: 6 }}>
          <Grid size={{ xs: 12, md: 6 }}>
            <Markdown source={`\`\`\`bash\n${MACOS_SCAN_COMMAND}\n\`\`\``} />
          </Grid>
        </Box>
      </Box>
    </Box>
  );
};
